import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/ui/Button'

interface Props {
  /** Şablon indirme sürüyor mu (buton pasif + gösterge). */
  downloading: boolean
  /** Dosya doğrulama sürüyor mu. */
  uploading: boolean
  onDownloadTemplate: () => void
  onFileSelected: (file: File) => void
}

/**
 * Tutanak Oluştur ekranındaki <b>Excel ile Toplu Yükleme</b> bölümü (088, US1): şablon indirme + dosya
 * seçme. Seçilen dosya doğrulanmak üzere üst bileşene verilir; ön izleme ayrı pop-up'ta gösterilir.
 *
 * <p>Uzantı kısıtı burada <b>ikinci savunma hattıdır</b> (`accept` + erken ret): kesin kontrol sunucuda
 * yapılır ve adı `.xlsx` yapılmış bir `.xls` orada workbook türünden yakalanır.
 */
export default function ExcelImportSection({
  downloading,
  uploading,
  onDownloadTemplate,
  onFileSelected,
}: Readonly<Props>) {
  const { t } = useTranslation()
  const inputRef = useRef<HTMLInputElement>(null)

  const pick = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    // Aynı dosyanın ikinci kez seçilebilmesi için input değeri sıfırlanır (tarayıcı aksi halde
    // change olayını tekrar üretmez) — "düzelt ve yeniden yükle" akışı buna dayanıyor.
    event.target.value = ''
    if (file) onFileSelected(file)
  }

  return (
    <section className="minutes-section">
      <div className="minutes-section-head">
        <h2>{t('minutes.excel.title')}</h2>
      </div>
      <p className="act-empty-hint">{t('minutes.excel.hint')}</p>
      <div className="mtg-doc-upload minutes-excel-actions">
        <Button
          type="button"
          variant="secondary"
          icon="pi pi-download"
          label={t('minutes.excel.downloadTemplate')}
          loading={downloading}
          disabled={downloading}
          onClick={onDownloadTemplate}
        />
        <Button
          type="button"
          variant="secondary"
          icon="pi pi-upload"
          label={uploading ? t('minutes.excel.uploading') : t('minutes.excel.chooseFile')}
          loading={uploading}
          disabled={uploading}
          onClick={() => inputRef.current?.click()}
        />
        <input
          ref={inputRef}
          type="file"
          accept=".xlsx"
          hidden
          data-testid="excel-file-input"
          onChange={pick}
        />
      </div>
    </section>
  )
}
